import { useAnalytics } from "@codat/analytics";
import { Button as OrchardButton } from "@codat/orchard-ui";
import { ButtonProps as OrchardButtonProps } from "@codat/orchard-ui/dist/es/components/Button";
import React, { forwardRef } from "react";

interface ButtonProps extends OrchardButtonProps {
  buttonName: string;
  eventProperties?: Record<string, unknown>;
}

export const Button = forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ButtonProps
>(function Button(props, ref) {
  const { buttonName, eventProperties, onClick, ...buttonProps } = props;
  const { sendEvent } = useAnalytics();

  const handleOnClickWithTracking = (
    e: React.MouseEvent<HTMLButtonElement & HTMLAnchorElement>
  ) => {
    if (onClick) {
      onClick(e);
    }
    sendEvent(`${buttonName} button - Click`, eventProperties);
  };

  /* eslint-disable @typescript-eslint/no-explicit-any */
  return (
    <OrchardButton
      {...buttonProps}
      onClick={handleOnClickWithTracking}
      ref={ref as React.RefObject<any>}
    />
  );
});
